import { Route } from 'react-router-dom';

import DeceasedCreate from './deceased-create/deceased-create.component';
import { DeceasedDetail } from './deceased-detail/deceased-detail.component';
import { DeceasedOverview } from './deceased-overview';
import { DeceasedUpdate } from './deceased-update/deceased-update.component';

export function DeceasedRoutes() {
    return (
        <Route path='deceased'>
            <Route
                index
                element={<DeceasedOverview />}
            />
            <Route
                path='create'
                element={<DeceasedCreate />}
            />
            <Route path=':deceasedId'>
                <Route
                    path='detail'
                    element={<DeceasedDetail />}
                />
                <Route
                    path='update'
                    element={<DeceasedUpdate />}
                />
            </Route>
        </Route>
    );
}
